<isav-page-content *ngIf="page$ | async as page">
    <isav-unpublished-warning
        [published]="!page.draft"
        contentName="Page"
        myContentPath="my-pages"
    ></isav-unpublished-warning>
    <isav-action-title [title]="page.title | isavTitleFallback : page['@id']">
        <a
            *isavHasEditAccess="page['@id']"
            [isavEditLink]="page"
            isavEditLinkProperty="title"
            isavBtn
            color="primary"
        >
            Edit
        </a>
        <button
            *isavHasCreateAccess="'Page'"
            [isavCloneContent]="page['@id']"
            isavBtn
            color="primary"
        >
            Clone
        </button>
        <button isavBtn color="primary" isavPrintPage>Print page</button>
    </isav-action-title>

    <div class="mt-5 mb-5 has-text-centered">
        <img *ngIf="page.image" [isavApiImg]="page.image" alt="" class="is-max-vh" />
        <isav-image-caption [iri]="page.image"></isav-image-caption>
    </div>
    <isav-content-editor-display
        class="is-block mb-2"
        [content]="page.body"
    ></isav-content-editor-display>
    <ng-container *ngIf="page.attachments.length">
        <a *ngIf="hiddenAttachments" (click)="hiddenAttachments = !hiddenAttachments">
            Show attachments ({{ page.attachments.length }})
        </a>
        <p class="mb-2" *ngIf="!hiddenAttachments && page.attachments.length">
            <strong>Attachments:&nbsp;</strong>
            <isav-files-link
                [iris]="page.attachments"
                [showLoaderWhileLoading]="true"
            ></isav-files-link>
        </p>
        <a *ngIf="!hiddenAttachments" (click)="hiddenAttachments = !hiddenAttachments">
            Hide attachments
        </a>
    </ng-container>
    <isav-page-content class="p-0">
        <isav-domain-event-journal-list
            [iri]="page['@id']"
            [showAll]="false"
            eventName="ContentFieldsUpdated"
        ></isav-domain-event-journal-list>
    </isav-page-content>
</isav-page-content>
